"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../../toolkit/styling");

var _SideMenuItem = _interopRequireDefault(require("./SideMenuItem"));

var _SideMenuSection = _interopRequireDefault(require("./SideMenuSection"));

var _dimen = require("../../../toolkit/dimen");

//
//  src/nav/side-menu/SideMenu.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 10/15/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* eslint-disable local-rules/use-link-component */

/* Lego Toolkit */

/* Relative Imports */
var SideMenu = (0, _mobxReact.observer)(function (props) {
  var dimenStore = _dimen.DimenStore.instance();

  var style = props.style,
      className = props.className,
      _props$hideOnSmallScr = props.hideOnSmallScreen,
      hideOnSmallScreen = _props$hideOnSmallScr === void 0 ? true : _props$hideOnSmallScr;
  var styles = useStylesheet();
  var children = useChildren(props);

  if (children.length == 0) {
    return null;
  }

  var isOpen = !dimenStore.isSmallScreen || !hideOnSmallScreen;

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, children);
});
SideMenu.Item = _SideMenuItem["default"];
SideMenu.Section = _SideMenuSection["default"];
var _default = SideMenu;
exports["default"] = _default;

var useChildren = function useChildren(props) {
  var children = props.children;
  return (0, _react.useMemo)(function () {
    var validChildren = _react["default"].Children.toArray(children).filter(function (e) {
      return /*#__PURE__*/_react["default"].isValidElement(e);
    });

    return validChildren;
  }, [children]);
};

var useStylesheet = function useStylesheet() {
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        overflowY: "auto"
      }
    });
  }, []);
};